import { InplaceContent, InplaceDisplay } from 'primereact/inplace'
import { InputText } from 'primereact/inputtext'
import { useCallback, useRef, useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { Button } from 'primereact/button'
import { CurrencyInputContainer, PaymentInputTextContainer } from './styles'

const VALIDATE_NUMS_REGEX = /[^\d]/g
const DEBOUNCE_MS = 1000

const CurrencyInput = ({ currency, onSelectCurrency }) => {
  const timerRef = useRef()
  const { t } = useTranslation()
  const [currencyText, setCurrencyText] = useState('')
  const [isCustomActive, setIsCustomActive] = useState(false)
  const handleToggleCustom = useCallback(() => {
    setIsCustomActive((isCustomActive) => !isCustomActive)
  }, [])
  const handleCurrencyTextChange = useCallback((e) => {
    clearTimeout(timerRef.current)
    const value = e.target.value
    const filteredValue = value.replace(VALIDATE_NUMS_REGEX, '')
    setCurrencyText(filteredValue)
    timerRef.current = setTimeout(() => {
      onSelectCurrency(parseFloat(filteredValue))
    }, DEBOUNCE_MS)
  }, [])
  const handleFocus = useCallback(() => {
    if (currencyText) {
      onSelectCurrency(parseFloat(currencyText))
    }
  }, [currencyText])

  return (
    <CurrencyInputContainer active={isCustomActive} onToggle={handleToggleCustom}>
      <InplaceDisplay>
        <Button>
          {t('custom')}
        </Button>
      </InplaceDisplay>
      <InplaceContent>
        <PaymentInputTextContainer className='p-input-icon-right'>
          <i>{currency}</i>
          <InputText
            onFocus={handleFocus}
            onChange={handleCurrencyTextChange}
            value={currencyText}
            className='p-inputtext-sm'
            autoFocus
          />
        </PaymentInputTextContainer>
      </InplaceContent>
    </CurrencyInputContainer>
  )
}

export default CurrencyInput
